// import KFocused from '../../core/mixins/focused/KFocused'
// import Icon from '../icon'
import Checkbox from '../checkbox'
import _ from 'lodash'

export default {
  name: 'KOption',
  inject: ['injectedData', 'onOptionClick', 'onOptionHover', 'onOptionUnHover', 'onOptionSelect', 'addOption', 'removeOption'],
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      validator: (value) => !_.isNil(value),
      // null
      default() {
        return null
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showCheckIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    selectedValue() {
      return this.injectedData.selectedValue
    },
    selected() {
      if (!this.multiple) {
        return this.value === this.selectedValue
      } else {
        return _.includes(this.selectedValue, this.value)
      }
    },
    hovered() {
      return this === this.injectedData.hoveredOption
    },
    multiple() {
      return this.injectedData.multiple
    },
  },
  watch: {
    selected: {
      immediate: true,
      handler() {
        this.onOptionSelect(this)
      },
    },
  },
  created() {
  },
  mounted() {
    this.addOption(this)
  },
  destroyed() {
    this.removeOption(this)
  },
  methods: {
    renderCheckedIcon() {
      if (!this.showCheckIcon) {
        return
      }

      if (!this.selected) {
        return
      }

      return <Checkbox
        ripple={false}
        class="km-option__checked-icon"
        checked
        // anim={this.multiple}
      />
    },
    renderLabel() {
      const label = this.$scopedSlots.default
        ? this.$scopedSlots.default({
          label: this.label,
          value: this.value,
          selected: this.selected,
          hovered: this.hovered,
        })
        : this.label
      return label
    },
    handleChange() {
      // console.log('changed....')
    },
    handleClick() {
      this.onOptionClick(this)
    },
    handleMouseEnter() {
      this.onOptionHover(this)
    },
    handleMouseLeave() {
      if (this.injectedData.keepHovered) {
        return
      }
      this.onOptionUnHover(this)
    },
  },
  render() {
    const optionCss = {
      'is-selected': this.selected,
      'is-hovered': this.hovered,
      'is-disabled': this.disabled,
      'km-option--multiple': this.multiple,
    }

    const events = {
      click: this.handleClick,
      mouseenter: this.handleMouseEnter,
      mouseleave: this.handleMouseLeave,
    }

    const label = this.renderLabel()
    const checkedIcon = this.renderCheckedIcon()

    return (
      <a class="km-option" {...{ class: optionCss }} {...{ on: events }}>
        <div class="km-option__label">
          {label}
        </div>
        {checkedIcon}
      </a>
    )
  },
}
